import { circadiaEngineProvider, localStorageProvider } from "../AppController";

const isCircadia = circadiaEngineProvider.isWindowCircadia();

export const isPIN = () => {
  if (isCircadia && localStorageProvider.get("sso") !== "true") return true;

  return false;
};
